import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

/*
** From https://github.com/egoist/vue-no-ssr
** With the authorization of @egoist
*/
import NoSsr from 'vue-no-ssr';
export default _objectSpread({}, NoSsr, {
  name: 'NoSsr'
});